import styled, { css } from 'styled-components'

import { ItemProps, ListProps } from './types'

export const List = styled('ul')<ListProps>`
  ${({
    theme,
    listStyle,
    listStyleType,
    marginTop = '0',
    paddingLeft = '0',
    gap = '0',
    gapMobile,
    textAlign = 'left',
    listStyleTypeImage,
    listStyleTypeImageCustom,
  }) => css`
    display: flex;
    flex-direction: column;

    gap: ${gap};
    margin-top: ${marginTop};
    padding-left: ${paddingLeft};
    text-align: ${textAlign};

    ${theme.below.tablet`
      margin-top: ${theme.newSpaces.sm}px;
    `}

    ${theme.below.mobileXL`
      gap: ${gapMobile};
    `}

    ${listStyle &&
    css`
      list-style: ${listStyle};
    `}

    ${listStyleType &&
    css`
      list-style-type: ${listStyleType};
    `}

    ${listStyleTypeImage &&
    css`
      list-style-image: url(${listStyleTypeImage});
    `}

    ${listStyleTypeImageCustom &&
    css`
      & :nth-child(even) {
        list-style-image: url(${listStyleTypeImageCustom.even});
      }

      & :nth-child(odd) {
        list-style-image: url(${listStyleTypeImageCustom.odd});
      }
    `}
  `}
`

export const Item = styled('li')<ItemProps>`
  ${({ theme, fontSize = 'body3', fontWeight }) => css`
    ${theme.getTypography('desktop', 'body', fontSize)};

    font-weight: ${fontWeight || 300};
    padding-left: ${theme.newSpaces.xs2}px;
  `}
`
